export const LEADERSHIP = [
  {
    debut: "Juil. 2025",
    fin: "Juil. 2026",
    poste: "Président",
    etablissement: "LEO Club Antananarivo Diavolana",
    details: "Planification d'actions communautaires, coordination des membres et pilotage de la visibilité du club.",
    en: {
      debut: "Jul. 2025",
      fin: "Jul. 2026",
      poste: "President",
      details: "Planning community actions, coordinating members and driving the club's visibility.",
    },
  },
  {
    debut: "Nov. 2023",
    fin: "Nov. 2024",
    poste: "Président exécutif",
    etablissement: "Association pour la Promotion de l'entrepreneuriat de l'ESPA (APEESPA)",
    details: "Établissement de partenariats pour financer les projets, supervision des opérations et des équipes.",
    en: {
      debut: "Nov. 2023",
      fin: "Nov. 2024",
      poste: "Executive President",
      details: "Building partnerships to fund projects, overseeing operations and teams.",
    },
  },
  {
    debut: "Mars 2024",
    fin: "Présent",
    poste: "Leader Commission Affaires Économiques et Financières",
    etablissement: "Mouvement Panafricain des Leaders à Madagascar",
    details: "Pilotage des initiatives économiques, coordination des membres et suivi des actions financières.",
    en: {
      debut: "Mar. 2024",
      fin: "Present",
      poste: "Economic & Financial Affairs Commission Leader",
      details: "Driving economic initiatives, coordinating members and monitoring financial actions.",
    },
  },
  {
    debut: "Nov. 2024",
    fin: "Nov. 2024",
    poste: "Participant",
    etablissement: "Emerging Malagasy Changemakers (EMC)",
    details: "Programme intensif sur le leadership, l'entrepreneuriat et la bonne gouvernance.",
    en: {
      poste: "Participant",
      details: "Intensive program on leadership, entrepreneurship and good governance.",
    },
  },
  {
    debut: "Mars 2023",
    fin: "Déc. 2023",
    poste: "Responsable relation extérieure",
    etablissement: "Polytechnician Electronics Engineering Collaboration (PEEC)",
    details: "Engagement communautaire, développement de collaborations et représentation externe de l'association.",
    en: {
      debut: "Mar. 2023",
      fin: "Dec. 2023",
      poste: "External Relations Officer",
      details: "Community engagement, building collaborations and external representation of the association.",
    },
  },
];
